export const getCompressedImageUrl = (oldUrl = '') =>
  oldUrl
    .replace('http://docs.pgiconsult.fr/rct/kepler/', 'http://docs.pgiconsult.fr/rct/kepler/')
    .replace(
      'http://docs.pgiconsult.fr/prod/kepler/',
      'http://docs.pgiconsult.fr/prod/kepler/',
    )
    .replace(
      'https://docs.pgiconsult.fr/prod/kepler/',
      'https://docs.pgiconsult.fr/prod/kepler/',
    )
    .replace(
      'https://docs.pgiconsult.fr/rct/kepler/',
      'https://docs.pgiconsult.fr/rct/kepler/',
    );
